"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationError = void 0;
class ValidationError {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ValidationError.attributeTypeMap;
    }
}
exports.ValidationError = ValidationError;
ValidationError.discriminator = undefined;
ValidationError.attributeTypeMap = [
    {
        "name": "loc",
        "baseName": "loc",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "msg",
        "baseName": "msg",
        "type": "string",
        "format": ""
    },
    {
        "name": "type",
        "baseName": "type",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=ValidationError.js.map